import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M12 8.6L9.07 13h5.86z",
  opacity: ".3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5 17h14v2H5zm7-12L5.33 15h13.34L12 5zm0 3.6l2.93 4.4H9.07L12 8.6z"
})), 'EjectTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/EjectTwoTone.js
// module id = 3322
// module chunks = 2